var map = {
	"./bill/router/index.js": 374,
	"./dada/router/index.js": 375,
	"./feedback/router/index.js": 376,
	"./franchise/router/index.js": 377,
	"./hotel/router/index.js": 378,
	"./lottery/router/index.js": 379,
	"./recommend/router/index.js": 380,
	"./sendcoupons/router/index.js": 381,
	"./topic/router/index.js": 382
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 759;


//////////////////
// WEBPACK FOOTER
// ./src/addon index\.js$
// module id = 759
// module chunks = 20